// Web stub for @capacitor/share — used when building for web/Docker
export const Share = {
  share: () => Promise.resolve(),
  canShare: () => Promise.resolve({ value: false }),
};
